import { render, staticRenderFns } from "./ConversationCustomAttributes.vue?vue&type=template&id=02fa18c0&scoped=true&"
import script from "./ConversationCustomAttributes.vue?vue&type=script&lang=js&"
export * from "./ConversationCustomAttributes.vue?vue&type=script&lang=js&"
import style0 from "./ConversationCustomAttributes.vue?vue&type=style&index=0&id=02fa18c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fa18c0",
  null
  
)

export default component.exports